import HighlightsInfoCardsContainer from './HighlightsInfoCardsContainer';

export default HighlightsInfoCardsContainer;
